(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function formatMoney(cents, root) {
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = root.getAttribute('data-locale') || 'en';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function initProduct(root) {
    var section = root.getAttribute('data-section');
    var jsonEl = document.getElementById('ProductJson-' + section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    var fieldsets = root.querySelectorAll('[data-option-index]');
    var thumbs = root.querySelectorAll('[data-thumb-id]');
    var items = root.querySelectorAll('[data-media-id]');

    function showMedia(id) {
      items.forEach(function (el) {
        el.hidden = String(el.getAttribute('data-media-id')) !== String(id);
      });
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(t.getAttribute('data-thumb-id')) === String(id) ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        showMedia(t.getAttribute('data-thumb-id'));
      });
    });

    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return [v.option1, v.option2, v.option3].slice(0, opts.length).every(function (o, i) {
          return o === opts[i];
        });
      })[0];
    }

    function update() {
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        var label = fs.querySelector('[data-option-label]');
        if (checked && label) label.textContent = checked.value;
      });

      var variant = findVariant(selectedOptions());
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      var price = formatMoney(variant.price, root);
      if (priceEl) {
        priceEl.textContent = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var s = document.createElement('s');
          s.textContent = formatMoney(variant.compare_at_price, root);
          priceEl.appendChild(s);
        }
        var span = document.createElement('span');
        span.textContent = price;
        priceEl.appendChild(span);
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart · ' + price : 'Sold out';
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      if (variant.featured_media && variant.featured_media.id) {
        showMedia(variant.featured_media.id);
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update();
    });
  }

  function initFilters() {
    var form = document.querySelector('[data-filter-form]');
    if (!form) return;

    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], input[type="number"]')) form.submit();
    });

    document.querySelectorAll('[data-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        form.submit();
      });
    });

    var box = document.querySelector('[data-filters]');
    if (box && window.matchMedia('(max-width: 899px)').matches) {
      box.removeAttribute('open');
    }
  }

  function initRecommendations() {
    document.querySelectorAll('[data-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.querySelector('.grid')) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recs]');
          if (fresh && fresh.querySelector('.grid')) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  ready(function () {
    document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
    initFilters();
    initRecommendations();
  });
})();
